import type { Editor } from '@tiptap/react'
import '@tiptap/extension-image' // augments Editor commands with setImage
import { api } from './api'
import { fileToBase64 } from './files'

export { fileToBase64 }

/** Upload an image File to the blob store and insert it at the caret as `![](url)`. */
export async function uploadAndInsertImage(editor: Editor, file: File): Promise<void> {
  const base64 = await fileToBase64(file)
  const { url } = await api.uploadImage(file.type || 'image/png', base64)
  editor.chain().focus().setImage({ src: url, alt: file.name }).run()
}
